var styles = {"box":"AsideMenuMobile_box_140f0_1","section":"AsideMenuMobile_section_140f0_18","shadow":"AsideMenuMobile_shadow_140f0_30","body":"AsideMenuMobile_body_140f0_47","aside":"AsideMenuMobile_aside_140f0_72","open":"AsideMenuMobile_open_140f0_75"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
